"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateUtils = exports.isValidHttpsUrl = exports.getStateColor = exports.scrollUp = exports.getImageData = exports.Encryption = void 0;
var auction_model_1 = require("../model/auction.model");
var image_set_1 = require("../model/image-set");
exports.Encryption = __importStar(require("./encryption"));
__exportStar(require("./json-storage"), exports);
function getImageData(file) {
    if (!file) {
        return Promise.resolve(new image_set_1.ImageMeta());
    }
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = function () {
            var img = new Image();
            var dataString = reader.result || '';
            img.src = dataString;
            img.onload = function () {
                var image = {
                    data: dataString,
                    size: file.size,
                    width: img.width,
                    height: img.height
                };
                resolve(image);
            };
        };
        reader.onerror = function (error) {
            reject(error);
        };
    });
}
exports.getImageData = getImageData;
function scrollUp(container) {
    if (container.current) {
        container.current.scrollTo(0, 0);
    }
}
exports.scrollUp = scrollUp;
function getStateColor(state) {
    switch (state) {
        case auction_model_1.AuctionState.ARCHIVED: return 'bg-secondary';
        case auction_model_1.AuctionState.NEW: return 'bg-primary';
        case auction_model_1.AuctionState.UPCOMING: return 'bg-warning';
        case auction_model_1.AuctionState.CURRENT: return 'bg-success';
        default: return 'bg-secondary';
    }
}
exports.getStateColor = getStateColor;
function isValidHttpsUrl(urlString) {
    var url;
    try {
        url = new URL(urlString);
    }
    catch (_a) {
        return false;
    }
    return url.protocol === 'https:';
}
exports.isValidHttpsUrl = isValidHttpsUrl;
var DateUtils = /** @class */ (function () {
    function DateUtils() {
    }
    DateUtils.timeRemaining = function (dateEnd) {
        var now = new Date();
        var diff = dateEnd.getTime() - now.getTime();
        return new Date(diff);
    };
    /**
     * @param t date object to perform offset on
     * @param offset amount of time to offset in ms
     */
    DateUtils.timeOffset = function (t, offset) {
        if (offset === void 0) { offset = -1000; }
        return new Date(t.getTime() + offset);
    };
    DateUtils.startOfDay = function () {
        var d = new Date();
        d.setHours(0, 0, 0, 0);
        return d;
    };
    DateUtils.endOfDay = function () {
        var d = new Date();
        d.setHours(23, 59, 59, 999);
        return d;
    };
    return DateUtils;
}());
exports.DateUtils = DateUtils;
